<app-navigate-back  class="absolute top-[10rem] left-8 z-10"></app-navigate-back>

<div class="relative w-full h-[400px] md:h-[500px] bg-cover bg-center bg-no-repeat flex items-center justify-center"
    [style.background-image]="'url(' + Images.LEADERSHIP_BANNER + ')'">
    <!-- Dark overlay for better text readability -->
    <div class="absolute inset-0 bg-black bg-opacity-40"></div>

    <!-- Centered Content -->
    <div class="relative z-10 text-center px-4">
        <h1 class="font-medium text-white text-3xl md:text-4xl mb-4">Careers&#64;VarrocConnect</h1>
        <p class="font-normal text-white text-xl md:text-2xl">Join Our Team</p>
    </div>
</div>